export default {"src":"https://fishbrain.com/_next/static/media/low.84b1732d.svg","height":37,"width":46,"blurWidth":0,"blurHeight":0};